import { render, staticRenderFns } from "./noPass.vue?vue&type=template&id=1f5e40ea&scoped=true"
import script from "./noPass.vue?vue&type=script&lang=js"
export * from "./noPass.vue?vue&type=script&lang=js"
import style0 from "./noPass.vue?vue&type=style&index=0&id=1f5e40ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e40ea",
  null
  
)

export default component.exports